import styled from 'styled-components';

export const UserText = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.palette.BR50};
  color: ${({ theme }) => theme.palette.D500};
  gap: 4px;
  font-size: 16px;
`;

export const BasketBox = styled.div`
  position: relative;
  cursor: pointer;
`;
